import { InputTypePattern } from '../../model/enumerations/InputTypePattern';
import { ValidationTypeEnum } from '../../model/enumerations/validation-type.enum';
import { OnSaveData } from '../../interfaces/on-save-data';
import { Component, Output, OnInit, Input, ViewEncapsulation, EventEmitter, ApplicationRef } from '@angular/core';
import { InputValidationService } from '../../../core/services/input-validation.service';
import { InputType } from '@supoui/shared/model/enumerations/input-type.enum';

@Component({
    selector: 'app-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InputComponent implements OnInit, OnSaveData {
  @Input() required: boolean;
  @Input() placeholder: string;
  @Input() name: string;
  @Input() withImage: boolean;
  @Input() value: any;
  @Input() disabled: boolean;
  @Input() validate: boolean;
  @Input() validationType: ValidationTypeEnum;
  @Input() isDate: boolean;
  @Input() isValid: boolean;
  @Input() maskPattern: string;
  @Input() maxTextLength = 100000;
  @Output() valueChange = new EventEmitter();
  @Output() saveModel = new EventEmitter();
  @Output() imageClicked = new EventEmitter();
  @Input() inputTypePattern: InputTypePattern = InputTypePattern.all;
  @Input() showEye: boolean;
  @Input() inputType: InputType = InputType.text;
  @Input() preventDefaultOnEnter = false;

  hideValue = true;
  oldValue: string;
  dateValue: Date | null;

  monthNames = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

  constructor(private inputValidationService: InputValidationService, private applicationRef: ApplicationRef) {
    if (this.placeholder === undefined) {
      this.placeholder = '';
    }
  }

  showHideValue(): void {
    this.hideValue = !this.hideValue;
  }

  onChange(): void {
    this.hideValue = false;
    this.valueChange.emit(this.value);
  }

  // get InputTypePattern() {
  //   return InputTypePattern;
  // }

  public formatDate(newValue: Date): void {
    if (newValue === null) {
      this.value = null;
      this.dateValue = null;
      return;
    }
    this.value = newValue;
    this.dateValue = new Date(this.value);
    this.value = this.convertDateToString(this.dateValue);
  }

  public getDateAsString(): any {
    if (this.dateValue === null) {
      return null;
    }
    return (
      this.dateValue.getFullYear() +
      '-' +
      ('0' + (this.dateValue.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + this.dateValue.getDate()).slice(-2)
    );
  }

  public getDate(): any {
    return this.dateValue;
  }

  onSaveModel(): void {
    if (this.oldValue !== this.value || this.isDate) {
      if (this.isDate && this.dateValue !== this.value) {
        this.dateValue = this.convertStringToDate(this.value);
        this.saveModel.emit();
        this.hideValue = true;
        return;
      }
      this.hideValue = true;
      this.saveModel.emit(this.value);
    }
  }

  onSaveState(): void {
    this.oldValue = this.value;
  }

  convertDateToString(val: Date): string {
    if (val != null && typeof val.getMonth === 'function') {
      const result = val.getDate().toString() + ' ' + this.monthNames[val.getMonth()] + ' ' + val.getFullYear().toString();
      return result;
    } else {
      return '';
    }
  }

  convertDateToJSONString(val: Date): string {
    if (val != null) {
      const result = val.getFullYear().toString() + '-' + val.getMonth().toString() + '-' + val.getDate().toString();
      return result;
    } else {
      return '';
    }
  }

  convertStringToDate(val: string): Date | null {
    if (val != null) {
      try {
        // dd MM yyyy
        // dd MMM yyyy
        let data = val.toString().split(' ');
        if (val.length === 8) {
          // ddMMyyyy
          data = [val.substr(0, 2), val.substr(2, 2), val.substr(4, 4)];
        }
        return new Date(
          parseInt(data[2], 10),
          this.monthNames.includes(data[1].toLowerCase()) ? this.monthNames.indexOf(data[1].toLowerCase()) : parseInt(data[1], 10) - 1,
          parseInt(data[0], 10)
        );
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        return null;
      }
    } else {
      return null;
    }
  }

  isValidated(val: any): boolean {
    return this.isValid === undefined ? this.inputValidationService.isValidated(val, this.validationType) : !this.isValid;
  }

  ngOnInit(): void {
    if (!this.value) {
      this.hideValue = false;
    }

    if (this.maxTextLength === undefined) {
      this.maxTextLength = 100000;
    }
  }

  get validationClass(): string {
    if (this.isValidated(this.value)) {
      switch (this.validationType) {
        case ValidationTypeEnum.required:
          return 'required-input';
        case ValidationTypeEnum.empty:
          return 'invalid-input';
        default:
          return 'input';
      }
    }
    return '';
  }

  onEnter(event: Event): void {
    if (this.preventDefaultOnEnter) {
      event.preventDefault();
      this.valueChange.emit(this.value);
    }
  }
}
